import {
  KEY_FOR_USER_NAME,
  KEY_FOR_USER_EMAIL,
  KEY_FOR_DESIGNATION,
  KEY_FOR_USER_ID,
  UPDATE_USER_ACCOUNT_BEGIN,
  UPDATE_USER_ACCOUNT_SUCCESS,
  UPDATE_USER_ACCOUNT_FAILURE,
} from './constants';
import http from '../../../common/http';
import { apiEndPoints } from '../../../common/globalConstants';
import { toast } from 'react-toastify';

export function updateUserAccount(id, updatedUserAccount) {
  return dispatch => {
    dispatch({
      type: UPDATE_USER_ACCOUNT_BEGIN,
    });
    const url = `${apiEndPoints.userManagement.PATCH_USER}`;
    const promise = new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append(KEY_FOR_USER_ID, id);
      formData.append(KEY_FOR_USER_NAME, updatedUserAccount.name);
      formData.append(KEY_FOR_USER_EMAIL, updatedUserAccount.email);
      formData.append(KEY_FOR_DESIGNATION, updatedUserAccount.designation);
      const doRequest = http.patch(url, formData);
      doRequest.then(
        res => {
          dispatch({
            type: UPDATE_USER_ACCOUNT_SUCCESS,
            data: { id: id, ...updatedUserAccount },
          });
          resolve(res);
        },
        err => {
          toast.error('User has not been updated');
          dispatch({
            type: UPDATE_USER_ACCOUNT_FAILURE,
          });
          reject(err);
        },
      );
    });
    return promise;
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case UPDATE_USER_ACCOUNT_BEGIN:
      return {
        ...state,
        updateUserAccountBegin: true,
        updateUserAccountFailure: false,
        updateUserAccountSuccess: false,
      };
    case UPDATE_USER_ACCOUNT_SUCCESS:
      const accountData = action.data;
      return {
        ...state,
        updateUserAccountBegin: false,
        updateUserAccountFailure: false,
        updateUserAccountSuccess: true,
        accounts: state.accounts.map(item => {
          if (item.id === accountData.id) {
            return { ...accountData };
          }
          return item;
        }),
      };
    case UPDATE_USER_ACCOUNT_FAILURE:
      return {
        ...state,
        updateUserAccountBegin: false,
        updateUserAccountFailure: true,
        updateUserAccountSuccess: false,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user-management/redux/updateUserAccount.js